
import visitorInfoWidgetTemplate from '../../templates/visitor_info/visitor_info.ejs';

import CompanyLevelBlockValidator from './CompanyLevelBlockValidator';
import addStyleText from './addStyleText';
import parseTemplate from './parseTemplate';
import GlobalVariables from '../GlobalVariables';
import PhoneCountryData from '../validators/PhoneContryData';
import PhoneValidator from '../validators/PhoneValidator';
import googleAnalyticsObjectInit from './googleAnalyticsObjectInit';
import getGaClientId from './getGaClientId';
import GetChatID from './GetChatID';
import isEnterKeyPressed from './isEnterKeyPressed';
import Cookies from './Cookies';
import getCookieValue from './getCookieValue';

const WebSmsFormValidator = (options) => {
    const init = function () {
        const me = this;
        me.options = options;
        me.$ = ApexChat.ApexChatJquery;
        me.context = me.options.context;
        me.elements = {
            formContainerSelector: '#apexchat_visitorInfo_container_wrapper',
            phoneContainerSelector: '#apexchat_visitorInfo_container_wrapper  .phone', // may or may not exist, defaults to the message container if not found
            phoneWarningSelector:
                me.options.phoneWarningSelector ||
                '#apexchat_visitorInfo_container_wrapper  .phone  span',
            phoneSelector: 'input[name=phone]',
            submitBtnSelector: '.submit-button',
            confirmationMessageSelector: '#apexchat_msg_sent',
            formVisitorSelector: '#apexchat_form_visitor',
            cancelBtnSelector: '.visitorinfo_close'
        };
        me.messages = {
            SENT: 'Thank You!',
            FAILED: 'Request submission failed',
            PLACEHOLDER_PHONE: 'Enter your mobile number'
        };
        me.styles = {
            SUBMIT_ENABLED: 'apexchat_enabled_submit',
            WARNING_ENABLED: 'apexchat_already_exist',
            ERROR_ENABLED: 'apexchat_error'
        };
        me.cookieTime = 60 * 60 * 3;
    };
    const reset = function () {
        const me = this;
        me.formSubmit = false;
        me.context.querySelector(me.elements.phoneContainerSelector)?.classList.remove(me.styles.WARNING_ENABLED);
        me.context.querySelector(me.elements.phoneWarningSelector)?.style.display = 'none'
        me.context.querySelector(me.elements.phoneSelector)?.value = '';
        me.context.querySelector(me.elements.submitBtnSelector)?.disabled = true;
        let confirmationMessageElement = me.context.querySelector(me.elements.confirmationMessageSelector);
        confirmationMessageElement?.parentNode.removeChild(confirmationMessageElement);
        me.context.querySelector(me.elements.submitBtnSelector)?.classList.remove(me.styles.SUBMIT_ENABLED);
    };
    const initialDisplay = function () {
        const me = this;
        const container = me.$(me.elements.formContainerSelector, me.context);
        if (container.length) {
            me.reset();
            me.show();
        } else {
            me.options.disclaimer = '';
            me.options.visitorTitle = parseTemplate(me.options.visitorTitle, me.options);
            const formHtml = visitorInfoWidgetTemplate(me.options);
            const form = me
                .$("<form id='apexchat_visitorInfo_container_wrapper'></form>", me.context)
                .append(formHtml);
            addStyleText(me.options.visitorInfoWidgetCss, 'apexchat_smspop_css');
            me.$(me.context.body).append(form);
            me.$(me.elements.phoneWarningSelector, me.context).hide();
            me.setPlaceHolder();
            me.bind();
        }
    };
    const bind = function () {
        const me = this;
        const buttonEl = me.context.querySelector(me.elements.submitBtnSelector);
        const epButtonEl = me.context.querySelector('.ep-submit-button');
        buttonEl.addEventListener('click', function () {
            me.$(this, me.context).prop('disabled', true);
            // var name = $('input[name=name]').val();
            const form = buttonEl.closest('form');
            const phone = form.querySelector(me.elements.phoneSelector)?.value;
            me.formSubmit = true;
            if (
                typeof GlobalVariables.CompanyLevelBlockedPages !== 'undefined' &&
                typeof GlobalVariables.CompanyContextRequest !== 'undefined'
            ) {
                me.companyLevelBlockValidator = new CompanyLevelBlockValidator(
                    GlobalVariables.CompanyLevelBlockedPages,
                    GlobalVariables.CompanyContextRequest,
                    GlobalVariables.CompanyLevelSettings
                );
            }
            if (
                me.companyLevelBlockValidator &&
                me.companyLevelBlockValidator.isSMSNumberBlocked(phone)
            ) {
                // check if typed number is blocked.
                return;
            }
            if (getCookieValue('livechat_web_sms_number') != phone) {
                const validator = Object.create(PhoneValidator);
                validator.phoneCountryData =
                    PhoneCountryData[ApexChat.options.countryCode || 'OTHER'];
                validator.phone = phone;
                const validate = validator.validate();
                if (validate) {
                    if (epButtonEl) {
                        epButtonEl.textContent = 'Sending...';
                        epButtonEl.classList.add('pointer-event-none');
                    }
                    buttonEl.textContent = 'Sending...';
                    buttonEl.classList.add('pointer-event-none');
                    startWebToSms();
                    function startWebToSms() {
                        var chatId = GetChatID(me.options);
                        me.getWebSmsService({ initiatedBy: me.options.chatInitiatedBy, phone: phone, interceptorResults: me.options.interceptorResult, chatId: chatId, serviceUrl: chatId ? '/Handlers/ConvertToSMSHandler.ashx' : '' }, function (res) {
                            me.$(me.elements.formVisitorSelector, me.context).hide();
                            let msgSent = me.messages.FAILED;// 'Request submission failed.'
                            if (res.success && res.data) {
                                msgSent = me.messages.SENT;
                                Cookies.setShort('livechat_web_sms_number', phone, me.cookieTime);
                            }
                            me.showMessage(msgSent);
                            buttonEl.textContent = 'Continue';
                            buttonEl.classList.remove('pointer-event-none');
                            if (epButtonEl) {
                                epButtonEl.textContent = 'Continue';
                                epButtonEl.classList.remove('pointer-event-none');
                            }
                            //toggle sms bottom sheet
                            me.$('#livechat_bottom_sheet_sms_close', me.context).click();
                            me.$('.apexchat_rd_transfer_to_sms', me.context).hide();
                        });
                    }
                } else {
                    me.showError();
                    if (epButtonEl) {
                        epButtonEl.textContent = 'Continue';
                        epButtonEl.classList.remove('pointer-event-none');
                    }
                    buttonEl.textContent = 'Continue';
                    buttonEl.classList.remove('pointer-event-none');
                }
            } else {
                me.showWarning();
            }
        });

        me.context.querySelector(me.elements.submitBtnSelector)?.disabled = true;
        me.context.querySelector(me.elements.phoneSelector)?.addEventListener('keypress', function (event) {
            if (isEnterKeyPressed(event)) {
                event.preventDefault();
                const epButtonEl = me.$('.ep-submit-button', me.context);
                if (epButtonEl.length > 0) {
                    epButtonEl.click();
                } else {
                    me.$(me.elements.submitBtnSelector, me.context).click();
                }

            }
            const originalPhone = me.$(this, me.context).val();
            if (!originalPhone) {
                const phone = originalPhone.replace(/[^+\d].+/, '');
                me.$(this, me.context).val(phone);
            }

            if (event.which < 48 || event.which > 57) {
                return false;
            }
        });
        me.context.querySelector(me.elements.cancelBtnSelector)?.addEventListener('click', (event) => {
            me.closeForm();
        });

        me.context.querySelector(me.elements.phoneSelector).addEventListener('keyup', (event) => {
            if (me.$(me.elements.phoneSelector, me.context).val() != '') {
                me.enableBtn();
            } else {
                me.disableBtn();
            }

            const form = buttonEl.closest('form');
            const phone = form.querySelector(me.elements.phoneSelector)?.value;
            const validator = Object.create(PhoneValidator);
            validator.phoneCountryData = PhoneCountryData[ApexChat.options.countryCode || 'OTHER'];
            validator.phone = phone;
            const validate = validator.validate();
            if (validate) {
                me.hideWarning();
                me.hideError();
            } else if (me.formSubmit) {
                me.hideWarning();
                me.showError();
            }
        });
        me.setPlaceHolder();
    };
    const show = function () {
        const me = this;
        me.$(me.elements.formVisitorSelector, me.context).show();
        me.$(me.elements.formContainerSelector, me.context).show();
    };

    const markDisable = function () {
        const me = this;
        me.context.querySelector(me.elements.submitBtnSelector,).disabled = true;
    };

    const disableBtn = function () {
        const me = this;
        me.markDisable();
        me.$(me.elements.submitBtnSelector, me.context).removeClass(me.styles.SUBMIT_ENABLED);
    };

    const enableBtn = function () {
        const me = this;
        me.$(me.elements.submitBtnSelector, me.context).prop('disabled', false);
        me.$(me.elements.submitBtnSelector, me.context).addClass(me.styles.SUBMIT_ENABLED);
    };
    const showError = function () {
        const me = this;
        me.$(me.elements.phoneWarningSelector, me.context).show();
        me.$(me.elements.phoneSelector, me.context).addClass(me.styles.ERROR_ENABLED);
    };

    const hideError = function () {
        const me = this;
        me.$(me.elements.phoneWarningSelector, me.context).hide();
        me.$(me.elements.phoneSelector, me.context).removeClass(me.styles.ERROR_ENABLED);
    };
    const showWarning = function () {
        const me = this;
        me.$(me.elements.phoneContainerSelector, me.context).addClass(me.styles.WARNING_ENABLED);
        me.$(me.elements.submitBtnSelector, me.context).removeClass(me.styles.SUBMIT_ENABLED);
        me.$(me.elements.phoneWarningSelector, me.context).show();
        me.$('.apexchat_error_message', me.context).hide();
        me.$('.apexchat_warning_message', me.context).show();
    };
    const hideWarning = function () {
        const me = this;
        me.$(me.elements.phoneContainerSelector, me.context).removeClass(me.styles.WARNING_ENABLED);
        me.$('.apexchat_warning_message', me.context).hide();
    };
    const showMessage = function (message) {
        const me = this;
        me.$(me.elements.formContainerSelector, me.context).append(
            `<div id="apexchat_msg_sent">${message}</div>`
        );
        setTimeout(() => {
            me.closeForm();
        }, 2000);
    };
    const closeForm = function () {
        const me = this;
        if (me.options.hide) {
            me.options.hide();
        } else {
            me.$(me.elements.formContainerSelector, me.context).fadeOut('slow');
        }
    };
    const setPlaceHolder = function () {
        const me = this;
        me.context.querySelector(me.elements.phoneSelector).placeholder =
            me.messages.PLACEHOLDER_PHONE

    };
    const getWebSmsService = function (payload, callback) {
        const me = this;
        if (!window.ga) {
            googleAnalyticsObjectInit('ga');
        }
        const gaClientId = getGaClientId(me.options.googleAnalyticsAccount, ga);
        const trafficCookie = getCookieValue('livechat_invitation_traffic_sources');
        const data = {
            visitationLogID: me.options.visitorId,
            companyId: me.options.companyId,
            initiatedBy: payload.initiatedBy,
            phone: payload.phone,
            visitorName: payload.name || '',
            language: me.options.language,
            chatInterceptorValue: me.interceptorResults,
            gaClientId,
            trafficCookie: trafficCookie || '',
            chatId: payload.chatId,
            chatLogId: payload.chatLogId
        };
        const serviceUrl = payload.serviceUrl || '/Handlers/SmsWebHandler.ashx';
        // ajax call to sms log call
        me.$.getJSON(GlobalVariables.LiveChatServiceUrl + serviceUrl, data, (result) => {
            console.log('sms webhandler requested....');
            callback(result);
        });
    };
    return {
        init,
        reset,
        initialDisplay,
        bind,
        show,
        markDisable,
        disableBtn,
        enableBtn,
        showError,
        hideError,
        showWarning,
        hideWarning,
        showMessage,
        closeForm,
        setPlaceHolder,
        getWebSmsService
    };
};
export default WebSmsFormValidator;
